/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_TitleInputs */

const en_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite & Get Rewards`)
};

const ar_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ادعُ واحصل على مكافآت`)
};

const de_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladen & Belohnungen erhalten`)
};

const es_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita y consigue recompensas`)
};

const fr_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter et obtenir des récompenses`)
};

const it_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita e ottieni ricompense`)
};

const ja_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待して報酬をゲット`)
};

const ko_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대하고 보상 받기`)
};

const pt_br_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convide e ganhe recompensas`)
};

const ru_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашайте и получайте награды`)
};

const th_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เชิญและรับรางวัล`)
};

const tr_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet et ve ödüller kazan`)
};

const zh_cn_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请拿奖励`)
};

const zh_tw_invite_page_title = /** @type {(inputs: Invite_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請拿獎勵`)
};

/**
* | output |
* | --- |
* | "Invite & Get Rewards" |
*
* @param {Invite_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_title = /** @type {((inputs?: Invite_Page_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_title(inputs)
	if (locale === "ar") return ar_invite_page_title(inputs)
	if (locale === "de") return de_invite_page_title(inputs)
	if (locale === "es") return es_invite_page_title(inputs)
	if (locale === "fr") return fr_invite_page_title(inputs)
	if (locale === "it") return it_invite_page_title(inputs)
	if (locale === "ja") return ja_invite_page_title(inputs)
	if (locale === "ko") return ko_invite_page_title(inputs)
	if (locale === "pt_br") return pt_br_invite_page_title(inputs)
	if (locale === "ru") return ru_invite_page_title(inputs)
	if (locale === "th") return th_invite_page_title(inputs)
	if (locale === "tr") return tr_invite_page_title(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_title(inputs)
	return zh_tw_invite_page_title(inputs)
});